
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-hub/category",
      function () {
        return require("private-next-pages/content-hub/category.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-hub/category"])
      });
    }
  